import { InterviewQuestionType } from '@/types/api';
import InterviewQuestionComponent from './InterviewQuestion.component';

export type InterviewQuestionProps = Pick<InterviewQuestionType, 'questionText'> & {
  onSave: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onCancelEdit: () => void;
  onChangeQuestion: (event: any) => void;
  id: string;
  isEditing: boolean;
  questionTitle: string;
  canEdit?: boolean;
  answer?: string;
};

export default function InterviewQuestion({
  id,
  questionText,
  onSave,
  isEditing,
  onDelete,
  onEdit,
  onChangeQuestion,
  onCancelEdit,
  questionTitle,
  answer,
  canEdit,
}: InterviewQuestionProps): JSX.Element {
  return (
    <InterviewQuestionComponent
      id={id}
      questionTitle={questionTitle}
      label={questionText}
      answer={answer}
      canEdit={canEdit}
      isEditing={isEditing}
      onChangeQuestion={onChangeQuestion}
      onTogglingEdit={isEditing ? onCancelEdit : onEdit}
      onSave={onSave}
      onDelete={onDelete}
    />
  );
}
